import { ValidationReturnType } from "../types/validation.ts";

const DataValidationUtil = {
  MIN_TEXT_LENGTH: 2,
  MAX_TEXT_LENGTH: 20,

  validateUsername(username: string): ValidationReturnType {
    const length = username.trim().length;

    if (username.trim() === "") {
      return {
        error: "Потребителското име е задължително",
        isValid: false,
      };
    }

    if (length < this.MIN_TEXT_LENGTH) {
      return {
        error: "Потребителското име е твърде кратко",
        isValid: false,
      };
    }

    if (length > this.MAX_TEXT_LENGTH) {
      return {
        error: "Потребителското име е твърде дълго",
        isValid: false,
      };
    }

    return {
      error: null,
      isValid: true,
    };
  },
  validatePassword(password: string): ValidationReturnType {
    if (password.length <= 0) {
      return {
        error: "Паролата е задължителна",
        isValid: false,
      };
    }

    return {
      error: null,
      isValid: true,
    };
  },
};

export default DataValidationUtil;
